import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const getUsersBilling = async (usersId) => {
  const response = await Axios.get(
    `${API_URL}/users/usersbillingdata?usersId=${usersId}`,
  );
  return response;
};

export { getUsersBilling };
